<template>
  <div>
    <div v-if="openType === 0">
      <el-descriptions style="margin: 0 20px 20px 20px" :column="2" border>
        <el-descriptions-item>
          <template slot="label">探视对象</template>
          {{addEditForm.toName}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">探视房间</template>
          {{addEditForm.toRoom}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">探视床位</template>
          {{addEditForm.bedName}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">探视人姓名</template>
          {{addEditForm.name}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">探视人身份证号</template>
          {{addEditForm.idCardNum}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">探视人电话</template>
          {{addEditForm.phone}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">与探视对象关系</template>
          {{addEditForm.relationShip}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">探视时间</template>
          {{addEditForm.vTime}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">探视人数</template>
          {{addEditForm.vpCnt}}人
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">车牌号</template>
          {{addEditForm.plateNumber}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">办理人员</template>
          {{addEditForm.applyEspName}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">预约时间</template>
          {{addEditForm.applyTime}}
        </el-descriptions-item>
        <el-descriptions-item span="2">
          <template slot="label">事由</template>
          {{addEditForm.remarks}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">实际探视时间</template>
          {{confirmForm.actualTime}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">实际探视人数</template>
          {{confirmForm.actualPcnt}}人
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">办理人员</template>
          {{confirmForm.confirmEspName}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">确认时间</template>
          {{confirmForm.confirmTime}}
        </el-descriptions-item>
        <el-descriptions-item span="2">
          <template slot="label">探视备注</template>
          {{confirmForm.remarks}}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div v-else-if="openType === 3">
      <el-descriptions style="margin: 0 20px 20px 20px" :column="2" border>
        <el-descriptions-item>
          <template slot="label">探视对象</template>
          {{addEditForm.toName}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">探视房间</template>
          {{addEditForm.toRoom}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">探视床位</template>
          {{addEditForm.bedName}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">探视人姓名</template>
          {{addEditForm.name}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">探视人身份证号</template>
          {{addEditForm.idCardNum}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">探视人电话</template>
          {{addEditForm.phone}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">与探视对象关系</template>
          {{addEditForm.relationShip}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">车牌号</template>
          {{addEditForm.plateNumber}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">探视时间</template>
          {{addEditForm.vTime}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">探视人数</template>
          {{addEditForm.vpCnt}}人
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">办理人员</template>
          {{addEditForm.applyEspName}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">预约时间</template>
          {{addEditForm.applyTime}}
        </el-descriptions-item>
        <el-descriptions-item span="2">
          <template slot="label">事由</template>
          {{addEditForm.remarks}}
        </el-descriptions-item>
      </el-descriptions>
      <el-form style="margin: 20px 20px 0 0" :model="confirmForm" :rules="confirmRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="实际探视时间" prop="actualTime">
              <el-date-picker v-fixZoom style="width: 100%" v-model="confirmForm.actualTime"
                              type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="xxxx-xx-xx xx:xx:xx" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实际探视人数" prop="actualPcnt">
              <el-input v-model="confirmForm.actualPcnt" placeholder="输入实际探视人数" onkeyup="value=value.replace(/[^\d]/g,'')">
                <template slot="append">人</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="探视备注" prop="">
          <el-input type="textarea" :rows="2" v-model="confirmForm.remarks" placeholder="输入探视备注"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="办理人员" prop="">
              <el-input disabled v-model="espName" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-else>
      <el-form style="margin: 20px 40px 0 0" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="探视对象" prop="pId">
              <el-select v-fixZoom v-model="addEditForm.pId" filterable placeholder="请选择" :clearable="true" style="width:100%;" @change="elderlyChange">
                <el-option v-for="item in elderlyArr" :key="item.index" :label="item.name" :value="item.id">
                  <span>{{ getSelectElderlyShow(item) }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="老人身份证号" prop="">
              <el-input disabled v-model="addEditForm.pIdCardNum" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="addEditForm.name" placeholder="输入探视人姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="">
              <el-input v-model="addEditForm.idCardNum" placeholder="输入探视人身份证号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话" prop="phone">
              <el-input v-model="addEditForm.phone" placeholder="输入探视人电话"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="关系" prop="relationShip">
              <el-select v-fixZoom v-model="addEditForm.relationShip" filterable placeholder="请选择" style="width: 100%">
                <el-option v-for="item in relationShipArr" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="探视时间" prop="vTime">
              <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.vTime"
                              type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="xxxx-xx-xx xx:xx:xx" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="探视人数" prop="vpCnt">
              <el-input v-model="addEditForm.vpCnt" placeholder="输入探视人数" onkeyup="value=value.replace(/[^\d]/g,'')">
                <template slot="append">人</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车牌号" prop="">
              <el-input v-model="addEditForm.plateNumber" placeholder="输入探视人车牌号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="办理人员" prop="">
              <el-input disabled v-model="espName" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="事由" prop="">
          <el-input type="textarea" :rows="2" v-model="addEditForm.remarks" placeholder="输入事由"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div style="height: 50px">
      <el-row v-if="openType !== 0" style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEdit('addEditForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
      <el-row v-else style="margin: 0 20px">
        <div class="cancel-btn" style="float: right" @click="closeAddEdit()">
          <span>关闭</span>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>

import {queryelderlyhasbed} from '../../../api/yanglaoyuan/elderly'
import {accomodationconfirmbedvisit, accomodationupdatebedvisit} from '../../../api/yanglaoyuan/homebed'

export default {
  name: 'addEditVisit',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    visitObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      eId: 0,
      espId: 0,
      espName: '',
      // 打开类型 0查看 1新增 2编辑 3确认
      openType: 0,
      row: '',
      elderlyArr: [],
      relationShipArr: [],
      pickerOptions: {},

      addEditForm: {
        pIdCardNum: '',
        pId: '',
        name: '',
        idCardNum: '',
        phone: '',
        relationShip: '',
        vTime: '',
        vpCnt: '',
        plateNumber: '',
        remarks: '',

        toName: '',
        toRoom: '',
        bedName: '',
        applyEspName: '',
        applyTime: ''
      },
      addEditRules: {
        pId: [{required: true, message: '请选择探视对象', trigger: 'change'}],
        name: [{ required: true, message: '请输入探视人姓名', trigger: 'blur' }],
        idCardNum: [{ required: true, message: '请输入探视人身份证号', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入探视人电话', trigger: 'blur' }],
        relationShip: [{ required: true, message: '请选择与探视对象关系', trigger: 'change' }],
        vTime: [{required: true, message: '请选择探视时间', trigger: 'change'}],
        vpCnt: [{ required: true, message: '请输入探视人数', trigger: 'blur' }]
      },
      confirmForm: {
        actualTime: '',
        actualPcnt: '',
        remarks: '',

        confirmEspName: '',
        confirmTime: ''
      },
      confirmRules: {
        actualTime: [{required: true, message: '请选择实际探视时间', trigger: 'change'}],
        actualPcnt: [{ required: true, message: '请输入实际探视人数', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.getStartData()
  },
  methods: {
    getStartData () {
      let loginResp = this.$store.state.user.LoginResp
      this.eId = loginResp.entity_id
      this.espId = loginResp.syspersonid
      this.espName = loginResp.personname
      this.relationShipArr = this.commonType.getRelationShipArr()

      this.openType = this.visitObj.openType
      this.row = this.visitObj.row

      if (this.openType === 1 || this.openType === 2) {
        this.getElderlyData()
      }

      if (this.openType === 0) {
        this.addEditForm.name = this.row.name
        this.addEditForm.idCardNum = this.row.idcard_num
        this.addEditForm.phone = this.row.phone
        this.addEditForm.relationShip = this.row.relationship
        this.addEditForm.vTime = this.row.v_time
        this.addEditForm.vpCnt = this.row.v_pcnt
        this.addEditForm.plateNumber = this.row.plate_number
        this.addEditForm.remarks = this.row.remarks
        this.addEditForm.toName = this.row.toname
        this.addEditForm.toRoom = this.row.toroom
        this.addEditForm.bedName = this.row.bed_name
        this.addEditForm.applyEspName = this.row.apply_esp_name
        this.addEditForm.applyTime = this.row.apply_time

        this.confirmForm.actualTime = this.row.actual_time
        this.confirmForm.actualPcnt = this.row.actual_pcnt
        this.confirmForm.remarks = this.row.confirm_remarks
        this.confirmForm.confirmEspName = this.row.confirm_esp_name
        this.confirmForm.confirmTime = this.row.confirm_time
      } else if (this.openType === 2) {
        this.addEditForm.pId = this.row.topid
        this.addEditForm.name = this.row.name
        this.addEditForm.idCardNum = this.row.idcard_num
        this.addEditForm.phone = this.row.phone
        this.addEditForm.relationShip = this.row.relationship
        this.addEditForm.vTime = this.row.v_time
        this.addEditForm.vpCnt = this.row.v_pcnt
        this.addEditForm.plateNumber = this.row.plate_number
        this.addEditForm.remarks = this.row.remarks
      } else if (this.openType === 3) {
        this.addEditForm.name = this.row.name
        this.addEditForm.idCardNum = this.row.idcard_num
        this.addEditForm.phone = this.row.phone
        this.addEditForm.relationShip = this.row.relationship
        this.addEditForm.vTime = this.row.v_time
        this.addEditForm.vpCnt = this.row.v_pcnt
        this.addEditForm.plateNumber = this.row.plate_number
        this.addEditForm.remarks = this.row.remarks
        this.addEditForm.toName = this.row.toname
        this.addEditForm.toRoom = this.row.toroom
        this.addEditForm.bedName = this.row.bed_name
        this.addEditForm.applyEspName = this.row.apply_esp_name
        this.addEditForm.applyTime = this.row.apply_time
      }
    },
    getSelectElderlyShow (item) {
      let elderlyName = item.name && item.name !== '' ? item.name : '--'
      let buildName = item.build_name && item.build_name !== '' ? item.build_name : '--'
      let floorName = item.floor_name && item.floor_name !== '' ? item.floor_name : '--'
      let roomName = item.room && item.room !== '' ? item.room : '--'
      let bedName = item.bed_name && item.bed_name !== '' ? item.bed_name : '--'
      return elderlyName + ' / ' + buildName + '--' + floorName + '--' + roomName + '--' + bedName
    },

    elderlyChange () {
      let elderly = this.elderlyArr.find(r => r.id === this.addEditForm.pId)
      if (elderly) {
        this.addEditForm.pIdCardNum = elderly.idcard_num
      }
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.openType === 1) {
            this.sendAdd()
          } else if (this.openType === 2) {
            this.sendEdit()
          } else if (this.openType === 3) {
            this.sendConfirm()
          }
        }
      })
    },
    sendAdd () {
      let data = {
        oper_type: 0,
        eid: this.eId,
        topid: this.addEditForm.pId,
        name: this.addEditForm.name,
        idcard_num: this.addEditForm.idCardNum,
        phone: this.addEditForm.phone,
        relationship: this.addEditForm.relationShip,
        v_time: this.addEditForm.vTime,
        v_pcnt: parseInt(this.addEditForm.vpCnt),
        plate_number: this.addEditForm.plateNumber,
        remarks: this.addEditForm.remarks,
        apply_esp_id: this.espId,
        apply_esp_name: this.espName
      }
      accomodationupdatebedvisit(data).then(res => {
        this.$notify({title: '成功', message: '成功预约探视', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },
    sendEdit () {
      let data = {
        oper_type: 1,
        id: this.row.id,
        eid: this.eId,
        topid: this.addEditForm.pId,
        name: this.addEditForm.name,
        idcard_num: this.addEditForm.idCardNum,
        phone: this.addEditForm.phone,
        relationship: this.addEditForm.relationShip,
        v_time: this.addEditForm.vTime,
        v_pcnt: parseInt(this.addEditForm.vpCnt),
        plate_number: this.addEditForm.plateNumber,
        remarks: this.addEditForm.remarks,
        apply_esp_id: this.espId,
        apply_esp_name: this.espName
      }
      accomodationupdatebedvisit(data).then(res => {
        this.$notify({title: '成功', message: '成功预约探视', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },
    sendConfirm () {
      let data = {
        rowid: this.row.id,
        actual_time: this.confirmForm.actualTime,
        actual_pcnt: parseInt(this.confirmForm.actualPcnt),
        confirm_remarks: this.confirmForm.remarks,
        confirm_esp_id: this.espId,
        confirm_esp_name: this.espName
      }
      accomodationconfirmbedvisit(data).then(res => {
        this.$notify({title: '成功', message: '成功确认探视', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },

    // 访问接口
    // 查询老人
    async getElderlyData () {
      let data = {
        e_id: this.eId
      }
      await queryelderlyhasbed({}, data).then(res => {
        this.elderlyArr = res.data.elderly
        if (this.openType === 2) {
          let elderly = this.elderlyArr.find(r => r.id === this.addEditForm.pId)
          if (elderly) {
            this.addEditForm.pIdCardNum = elderly.idcard_num
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditVisit.vue